module.exports = __webpack_public_path__ + "img/buck-mob-logo-red.e87e8db5.svg";